/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _sliceInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/slice";import error from"../base/error";import isArray from"./isArray";const remove=function(r,e,o){if(!isArray(r))throw new error.Generic("ArrayRemoveError","Type is not an array");if(e>=r.length||o&&o>=r.length)throw new error.Generic("ArrayRemoveError","Range is out of the array length");let t=_sliceInstanceProperty(r).call(r,(o||e)+1||r.length);return r.length=e<0?r.length+e:e,r.push(...t)};export default remove;